import React, { useContext, useEffect, useState, useRef } from "react";
import {
	Button,
	Dropdown,
	FormRow,
	InputBox,
	Loader,
	Popup,
	Table,
} from "../../components";
import {
	PayslipFormHeadData,
	filterDateMonth,
	dropDownPagination,
} from "../../data";
import ApiCall from "../../utils/ApiCall";
import AuthContext from "../../contexts/AuthContext";
import { PAYPAYSLIPGENERATION } from "../../Constants";
import SweetAlert from "../../utils/SweetAlert";

const PayslipGeneration = () => {
	const year = new Date().getFullYear();
	const ptDropdownRef = useRef(null);
	const { authTokens } = useContext(AuthContext);
	const [showPTDropdown, setShowPTDropdown] = useState(false);
	const [professionalTaxMonths, setProfessionalTaxMonths] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const [payslipGenerate, setPayslipGenerate] = useState([]);
	const [searchData, setSearchData] = useState("");
	const [currentPage, setCurrentPage] = useState(1);
	const [payslipGeneratePopup, setPayslipGeneratePopup] = useState(null);
	const [selectedYear, setSelectedYear] = useState(year);
	const [selectedMonth, setSelectedMonth] = useState("");
	const [pagination, setPagination] = useState(100000);
	const rowPerPage = 7;

	useEffect(() => {
	const handleClickOutside = (event) => {
		if (
			ptDropdownRef.current &&
			!ptDropdownRef.current.contains(event.target)
		) {
			setShowPTDropdown(false);
		}
	};

	document.addEventListener("mousedown", handleClickOutside);

	return () => {
		document.removeEventListener(
			"mousedown",
			handleClickOutside
		);
	};
}, []);

	useEffect(() => {
		fetchData();
		const savedPagination = sessionStorage.getItem(
			"payslip-generation-pagination-data"
		);
		if (savedPagination) {
			setPagination(JSON.parse(savedPagination));
		}
	}, [pagination]);

	const fetchData = async () => {
		try {
			const res = await ApiCall(
				`${PAYPAYSLIPGENERATION}?pg_r=${pagination}`,
				"GET",
				authTokens,
				null
			);
			//console.log("res", res.data);
			setPayslipGenerate(res.data.payslipgen);
			setIsLoading(false);
		} catch (error) {
			console.log("Error While Fetching Data", error);
			setIsLoading(false);
		}
	};

	const handlePTMonthChange = (month) => {
	setProfessionalTaxMonths((prev) =>
		prev.includes(month)
			? prev.filter((item) => item !== month)
			: [...prev, month]
	);
};

const availablePTMonths = filterDateMonth.filter(
	(item) =>
		item.label !== "Select" &&
		String(item.value) === String(selectedMonth)
);

	const handleProfessionalTaxMonth = (e) => {
	const values = Array.from(
		e.target.selectedOptions,
		(option) => option.value
	);
	setProfessionalTaxMonths(values);
};

	const handlePageChange = (pageNumber) => {
		setCurrentPage(pageNumber);
	};

	const paginatedData = (e) => {
		e.preventDefault();
		setPagination(e.target.value);
		const pageValue = e.target.value;
		sessionStorage.setItem(
			"payslip-generation-pagination-data",
			JSON.stringify(pageValue)
		);
	};

	const handleYear = (e) => {
		e.preventDefault();
		setSelectedYear(e.target.value);
	};

	const handleMonth = (e) => {
	e.preventDefault();

	const month = e.target.value;

	setSelectedMonth(month);

	// Clear previous PT selections
	setProfessionalTaxMonths([]);
};

	const handleSearch = (e) => {
		setSearchData(e.target.value);
	};

	const searchedData = payslipGenerate.filter((item) =>
		item.email.toLowerCase().includes(searchData.toLowerCase())
	);

	const handlePayslipGenerate = (rowIndex) => {
		if (searchedData.length > 7) {
			const actualIndex = (currentPage - 1) * rowPerPage + rowIndex;
			const id = searchedData[actualIndex].id;
			setPayslipGeneratePopup(id);
		} else {
			const correctIndex = payslipGenerate.findIndex(
				(item) => item.id === searchedData[rowIndex].id
			);
			const id = payslipGenerate[correctIndex].id;
			setPayslipGeneratePopup(id);
		}
	};

	const handlePayslipGenerateData = async (e) => {
		e.preventDefault();
		const params = {
			emp_id: payslipGeneratePopup || "",
			year: selectedYear || "",
			month: selectedMonth || "",
			professional_tax_months: professionalTaxMonths,
		};
		setPayslipGeneratePopup(null);
		setSelectedMonth("");
		setSelectedYear(year);
		setProfessionalTaxMonths([]);
		//console.log("params", params);
		try {
			const res = await ApiCall(
				PAYPAYSLIPGENERATION,
				"POST",
				authTokens,
				params
			);
			if (res.status === 200) {
				SweetAlert({ title: "Successfully Generated", icon: "success" });
			} else {
				SweetAlert({ title: "Something went wrong", icon: "error" });
			}
		} catch (error) {
			console.log("Error While Fetching Data", error);
		}
	};
	return (
		<div className="w-auto my-6 flex flex-col mx-6 py-4 px-2 justify-center">
			<h2 className="text-lg intro-x table-body-td px-2 font-semibold">
				Pay Slips Generation
			</h2>
			{isLoading ? (
				<div className="w-full h-[60vh] flex items-center justify-center">
					<Loader />
				</div>
			) : (
				<>
					<div className="p-2 flex justify-between w-full mt-4 intro-x">
						<InputBox
							value={searchData}
							onChange={handleSearch}
							placeholder="Search"
							type="search"
						/>
						{/* <Dropdown
							style="px-4"
							value={pagination}
							onChange={paginatedData}
							options={dropDownPagination}
						/> */}
					</div>
					<Table
						tableStyle="border-spacing-y-[10px] border-separate -mt-4"
						bodyStyle="bg-accent box-shadow"
						header={PayslipFormHeadData}
						body={searchedData.map((row) => [
							row.email,
							row.emp,
							row.designation,
							row.ctc,
						])}
						btnstyle="intro-x"
						bodyTdStyle="table-body-td intro-x"
						headTdStyle="table-body-td intro-x"
						btnTitle="Generate"
						paginationNeed={searchedData.length > 7 ? true : false}
						currentPage={currentPage}
						rowPerPage={rowPerPage}
						paginationBody={payslipGenerate}
						onPageChange={handlePageChange}
						onClick={handlePayslipGenerate}
					/>
					{payslipGeneratePopup && (
						<Popup
							title="Generate Payroll"
							trigger={payslipGeneratePopup}
							setTrigger={setPayslipGeneratePopup}
							popupstyle="md:w-2/5 w-full"
						>
							<form onSubmit={handlePayslipGenerateData}>
								<FormRow
									label="Year"
									item={
										<InputBox
											value={selectedYear}
											onChange={handleYear}
											style="w-full"
											type="number"
										/>
									}
								/>
								<FormRow
									label="Month"
									item={
										<Dropdown
											value={selectedMonth}
											options={filterDateMonth}
											onChange={handleMonth}
											style="w-full cursor-pointer"
										/>
									}
								/>

								<FormRow
    label="Professional Tax Month"
    item={
        <div ref={ptDropdownRef} className="relative w-full">
            <div
	onClick={() => setShowPTDropdown(!showPTDropdown)}
	className="
		w-full
		min-h-[42px]
		border
		rounded-md
		px-3
		py-2
		cursor-pointer
		flex
		items-center
		justify-between
	"
>
	<div className="flex flex-wrap gap-1">
	{professionalTaxMonths.length > 0 ? (
		professionalTaxMonths.map((monthValue) => {
			const monthObj = filterDateMonth.find(
				(m) => String(m.value) === String(monthValue)
			);

			return (
				<span
					key={monthValue}
					className="
						flex
						items-center
						gap-1
						px-2
						py-1
						bg-button
						text-white
						rounded
						text-xs
					"
				>
					{monthObj?.label}

					<button
						type="button"
						className="
							ml-1
							text-white
							font-bold
							hover:text-red-300
							cursor-pointer
						"
						onClick={(e) => {
							e.stopPropagation();

							setProfessionalTaxMonths((prev) =>
								prev.filter(
									(item) =>
										String(item) !==
										String(monthValue)
								)
							);
						}}
					>
						✕
					</button>
				</span>
			);
		})
	) : (
		<svg
	className={`w-4 h-4 transition-transform ${
		showPTDropdown ? "rotate-180" : ""
	}`}
	fill="none"
	stroke="currentColor"
	viewBox="0 0 24 24"
>
	<path
		strokeLinecap="round"
		strokeLinejoin="round"
		strokeWidth={2}
		d="M19 9l-7 7-7-7"
	/>
</svg>
	)}
</div>
</div>
            {showPTDropdown && (
                <div
                    className="
                        absolute
                        top-full
                        left-0
                        mt-1
                        w-full
                        bg-accent
                        border
                        rounded-md
                        shadow-xl
                        z-[9999]
                        max-h-56
                        overflow-y-auto
                    "
                >
                    {availablePTMonths
                        .filter(
		(m) =>
			m.label !== "Select" &&
			m.value !== "" &&
			m.value !== null
	)
                        .map((month) => (
                            <label
                                key={month.value}
                                className="
                                    flex
                                    items-center
                                    gap-2
                                    px-3
                                    py-2
                                    hover:bg-button/20
                                    cursor-pointer
                                "
                            >
                                <input
                                    type="checkbox"
                                    checked={professionalTaxMonths.includes(
                                        month.value
                                    )}
                                    onChange={() =>
                                        handlePTMonthChange(
                                            month.value
                                        )
                                    }
                                />
                                {month.label}
                            </label>
                        ))}
                </div>
            )}
        </div>
    }
/>
								<div className="text-center">
									<Button classname="w-auto my-4 text-white text-sm font-semibold py-2 rounded-md px-6 bg-button">
										Submit
									</Button>
								</div>
							</form>
						</Popup>
					)}
				</>
			)}
		</div>
	);
};

export default PayslipGeneration;
